export function getUrlParameterValue(parameterName: string) {
  const paramRgx = new RegExp(parameterName + '=(.*?)($|&)', 'i');
  const paramValue = window.location.search.match(paramRgx);

  if (paramValue) {
    return paramValue[1] || '';
  }

  return '';
}
